import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { AboutBlocks } from './AboutBlocks';
import { AboutGraph } from './AboutGraph';
import LinkBack from '../widgets/LinkBack';
import Typography from '../widgets/Typography/Typography';

import './about.scss';

class StaticPageTemplate extends PureComponent {
  render() {
    const { meta, info, blocks, graph } = this.props.content;

    return (
      <div className="about">
        {(meta) &&
          <Helmet>
            <title>{meta.title}</title>
          </Helmet>
        }

        <div className="container">
          <div className="about-info">
            <LinkBack link="/we/subnavigation/">
              Мы <i>вернуться</i>
            </LinkBack>

            <Typography content={info}/>
          </div>

          <div className="about-panel">
            <AboutBlocks
              blocks={blocks}
            />

            <AboutGraph
              graph={graph}
            />
          </div>
        </div>
      </div>
    );
  }
}

StaticPageTemplate.propTypes = {
  content: PropTypes.shape({
    meta: PropTypes.shape({
      title: PropTypes.string
    }),
    info: PropTypes.arrayOf(PropTypes.object),
    blocks: PropTypes.arrayOf(PropTypes.object),
    graph: PropTypes.shape({
      title: PropTypes.string,
      image: PropTypes.string
    })
  })
};

export default StaticPageTemplate;



// WEBPACK FOOTER //
// ./src/components/About/AboutTemplate.js